import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs/Subject";
import { Subscription } from "rxjs/Subscription";
import { BillTypeService } from "../../shared/bill/bill-type.service";
import { CommunityService } from "../../shared/services/community/community.service";
import { debounceTime } from "rxjs/operator/debounceTime";
import { LoaderService } from "../../shared/services/loader.service";

@Component({
  selector: "app-view-bill-type",
  templateUrl: "./view-bill-type.component.html",
  styleUrls: ["./view-bill-type.component.css"]
})
export class ViewBillTypeComponent implements OnInit, OnDestroy {
  private _alert = new Subject<string>();
  billType;
  billTypeId;
  community;
  listedCommunities: Array<any>;
  communities;
  availableCommunities;
  subscriberCommunities;
  billTypeSubscription: Subscription;
  communitiesSubscription: Subscription;
  routeSubscription: Subscription;
  subscriberCommunitiesSubscription: Subscription;
  actionMessage: string;
  successMessage: string;
  errorMessage: string;
  modalReference: NgbModalRef;
  subscription: Subscription;
  query;
  page = 1;
  activeRouteIndex: number;

  constructor(
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private billTypeService: BillTypeService,
    private communityService: CommunityService,
    private loaderService: LoaderService
  ) {
    this.communities = [];
    this.subscriberCommunities = [];
    this.community = "default";
    this.listedCommunities = [];
  }

  ngOnInit(): void {
    this.query = "";
    this.routeSubscription = this.route.params.subscribe(params => {
      this.billTypeId = params.billTypeId;
      this.activeRouteIndex = params.index;
    });
    this.billTypeSubscription = this.billTypeService
      .getBillType(this.billTypeId)
      .subscribe(billType => {
        this.billType = billType;
      });
    this.communitiesSubscription = this.communityService
      .getCommunities()
      .subscribe(communities => {
        this.communities = communities.sort((a, b) => {
          const nameA = a.name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.name.toUpperCase(); // ignore upper and lowercase
          const result = nameA < nameB ? -1 : nameA > nameB ? 1 : 0;

          return result;
        });
      });
    this.billTypeService
      .getCommunitiesByBillTypeId(this.billTypeId)
      .subscribe((data: Array<any>) => {
        this.subscriberCommunities = data.filter(datum => datum !== undefined);
      });
    this.loaderService.stopLoader();
  }

  ngOnDestroy(): void {
    this.billTypeSubscription.unsubscribe();
    this.communitiesSubscription.unsubscribe();
    this.routeSubscription.unsubscribe();
  }

  confirmAction(community, modal, action): void {
    this.community = community;
    if (action === "enable") {
      this.actionMessage = "Are you sure you want to enable " + community.name + " for " + this.billType.name + "?";
    } else if (action === "disable") {
      this.actionMessage = "Are you sure you want to disable " + community.name + " from " + this.billType.name + "?";
    }
    this.open(modal, "sm");
  }

  toggleStatus(): void {
    if (this.community.status === "enabled") {
      this.billTypeService.deactivateCommunity(
        this.billTypeId,
        this.community.id
      );
      this.showAlert(
        true,
        `${this.billType.name} deactivated for ${this.community.name}`
      );
    } else {
      this.billTypeService.reactivateCommunity(
        this.billTypeId,
        this.community.id
      );
      this.showAlert(
        true,
        `${this.billType.name} reactivated for ${this.community.name}`
      );
    }
    this.close();
  }

  showAddModal(modal): void {
    this.availableCommunities = this.communities.filter(community => {
      return !this.subscriberCommunities.find(subscriberCommunity => {
        return community.id === subscriberCommunity.id;
      });
    });
    this.community = "default";
    this.open(modal, "md");
  }

  addCommunity(): void {
    if (this.community !== "default") {
      const selectedCommunity = this.communities.filter(
        community => community.id === this.community
      );
      for (const listedCommunity of this.listedCommunities) {
        if (listedCommunity.name === selectedCommunity[0].name) {
          const msgType = false;
          const msg = "That community has been added already.";
          this.showAlert(msgType, msg);

          return;
        }
      }
      this.listedCommunities.push({
        name: selectedCommunity[0].name,
        id: selectedCommunity[0].id
      });
      this.community = "default";
    }
  }

  removeCommunity(index): void {
    this.listedCommunities.splice(index, 1);
  }

  update(): void {
    this.billTypeService.addCommunitiesToBillType(
      this.billType,
      this.listedCommunities
    );
    this.listedCommunities.forEach(element => {
      this.communities.push(element);
    });
    this.close();
    const length = this.listedCommunities.length;
    const word = length === 1 ? "community has" : "communities have";
    const msgType = true;
    const msg = "The " + word + " been successfully added to this bill type.";
    this.showAlert(msgType, msg);
    this.listedCommunities = [];
  }

  open(modal, modalSize): void {
    this.modalReference = this.modalService.open(modal, { size: modalSize });
  }

  close(): void {
    this.modalReference.close();
  }

  showAlert(msgType, msg): void {
    this.subscription = this._alert.subscribe(
      message =>
        msgType
          ? (this.successMessage = message)
          : (this.errorMessage = message)
    );
    debounceTime
      .call(this._alert, 3000)
      .subscribe(
        () =>
          msgType
            ? (this.successMessage = undefined)
            : (this.errorMessage = undefined)
      );
    this._alert.next(msg);
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/bill/view-bill-type/view-bill-type.component.ts